import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import TrovityIcon from 'src/assets/Buy_Policy_Images/TrovityIcon.svg'
import Cup from 'src/assets/Buy_Policy_Images/Cup.svg'
import Filters from 'src/assets/Buy_Policy_Images/Filters.svg'
import CoffeeBeans from 'src/assets/Buy_Policy_Images/CoffeeBeans.svg'
import manImage from 'src/assets/Buy_Policy_Images/ManHand.svg'
import { useHistory } from 'react-router-dom'
import {
  CURRENT_STATUS,
  ENCOUNTERED_ERROR_WHILE_SAVING,
  INSURANCE_CATOGORIES,
  INSURANCE_TYPE_CATOGORIES,
} from 'src/utils/constants/BuyPolicy'
import { useDispatch, useSelector } from 'react-redux'
import { showNotificationMessage, updateTrust } from 'src/actions'
import { addScroll } from 'src/utils/commonMethods'
import {
  fetchTokenForBuyPolicy,
  saveISNPStatus,
} from 'src/services/buyPolicyService'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import LoadingModal from 'src/components/common/LoadingModal'
import { getISNPStatusRequestBody } from 'src/utils/commonMethods/buyPolicy'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'

const QuoteConformation = () => {
  const classes = useStyles()
  const history = useHistory()
  const guestUserDetails = useSelector((state) => state?.buyPolicyReducer)
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()

  const handleContainerSelect = (container) => {
    dispatch(updateTrust(container))
    addScroll()
    saveMetadataAndNavigate()
  }

  const saveISNPStatusTasks = async (token) => {
    setLoading(true)
    const formData = getISNPStatusRequestBody(
      guestUserDetails,
      INSURANCE_TYPE_CATOGORIES?.health,
      CURRENT_STATUS?.homeScreen
    )

    saveISNPStatus(token, formData)
      .then((response) => {
        // This is the response which is coming from backend.
        // The responseData is returned as a promise which is handled in following then block

        return response?.res?.data
      })
      .then(() => {
        // The responseData is returned here and main logic as per requirements will be handled here

        setLoading(false)
        history.push('/individual/dashboard/buyPolicy/health/insuranceDetails')
      })
      .catch(() => {
        // If there is any error from the backend it will be handled here

        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: ENCOUNTERED_ERROR_WHILE_SAVING,
          })
        )
      })
  }

  const saveMetadataAndNavigate = () => {
    setLoading(true)

    fetchTokenForBuyPolicy()
      .then((token) => {
        setLoading(false)
        saveISNPStatusTasks(token)
      })
      .catch(() => {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
          })
        )
      })
  }

  return (
    <>
      <LoadingModal loading={loading} />
      <div className={classes.rootContainer}>
        <div className={classes.headingContainer}>
          <span className={classes.quoteContent}>To View Quotes, </span>
          <span className={classes.quoteAction}>select one of the options</span>
        </div>
        <div className={classes.overallContainer}>
          <div className={classes.imageContainer}>
            <img src={manImage} alt='man' className={classes.imageContent} />
          </div>
          <div className={classes.buttonContainer}>
            <div
              id='trustTrovityButton'
              className={classes.trovityContent}
              onClick={() =>
                handleContainerSelect(INSURANCE_CATOGORIES?.trustTrovity)
              }
            >
              <div className={classes.trustTrovityContainer}>
                <div className={classes.trovityContentAction}>
                  <span className={classes.trovityParagraph}>
                    I TRUST TROVITY
                  </span>
                </div>
                <div className={classes.trovityImageAction}>
                  <img
                    src={TrovityIcon}
                    alt='Trovity'
                    className={classes.trustTrovityIcon}
                  />
                </div>
              </div>
              <div className={classes.cupContainer}>
                <div className={classes.cupImageAction}>
                  <img src={Cup} alt='cup' />
                </div>
                <div className={classes.cupContentAction}>
                  <p className={classes.cupParagraph}>
                    SIP A COFFEE & RELY ON US
                  </p>
                </div>
              </div>
            </div>
            <div className={classes.orButtonContainer}>
              <p className={classes.orButtonContent}>or</p>
            </div>

            <div
              id='manualSelectionButton'
              className={classes.customContainer}
              onClick={() =>
                handleContainerSelect(INSURANCE_CATOGORIES?.manualSelection)
              }
            >
              <div className={classes.customAction}>
                <div className={classes.customContent}>
                  <span className={classes.customParagraph}>
                    CUSTOMIZE MANUALLY
                  </span>
                </div>
                <div className={classes.vectorImageAction}>
                  <img src={Filters} alt='hello' />
                </div>
              </div>
              <div className={classes.customParagraphAction}>
                <div className={classes.cupImageAction}>
                  <img src={CoffeeBeans} alt='CoffeeBeans' />
                </div>
                <p className={classes.customParagraphContent}>
                  IT&apos;S OK! I MAKE MY OWN CHOICE
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default QuoteConformation

const useStyles = makeStyles({
  rootContainer: {
    display: 'flex',
    flexDirection: 'column',
    // background: '#FFFFFF',
    borderRadius: '5px',
    maxWidth: '600px',
    background: 'linear-gradient(163.89deg, #EF669B -500.7%, #FFFFFF 85.86%)',
  },
  headingContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    background: 'rgba(102, 48, 69, 0.1)',
    padding: '30px',
  },
  quoteContent: {
    fontSize: '27px',
    color: '#92516A',
  },
  quoteAction: {
    fontSize: '18px',
  },
  overallContainer: {
    display: 'flex',
    padding: '10%',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  buttonContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '30px',
    width: '70%',
  },
  trovityContent: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  trustTrovityContainer: {
    display: 'flex',
    alignItems: 'center',
    background: 'linear-gradient(82.38deg, #2A90BC -90.09%, #FEFEFE 73.88%)',
    boxSizing: 'border-box',
    borderRadius: '6px',
    boxShadow: '0px 5px 10px 0px #00000026',
    '&:hover': {
      boxShadow: '0px 5px 10px 0px rgba(42, 144, 188, 0.7)',
    },
    height: '90px',
    overflow: 'hidden',
  },
  trovityContentAction: {
    padding: '5px',
    width: '80%',
    display: 'flex',
    alignItems: 'center',
    // justifyContent: 'center',
  },
  trovityParagraph: {
    fontSize: '17px',
    color: '#2B8AA4',
    fontWeight: '600',
    textAlign: 'center',
    width: '80%',
  },
  trovityImageAction: {
    width: '25%',
    height: '100%',
    paddingRight: '15px',
  },
  cupContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '-2%',
    alignItems: 'center',
    justifyContent: 'end',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  cupParagraph: {
    fontSize: '13px',
    fontStyle: 'italic',
    color: '#8D8D8D',
  },
  cupContentAction: {
    paddingLeft: '2%',
    marginTop: '-1%',
  },
  customContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    cursor: 'pointer',
  },
  customAction: {
    display: 'flex',
    flexDirection: 'row',
    boxSizing: 'border-box',
    background: 'linear-gradient(75.18deg, #EF669B -161.32%, #FFFFFF 78.47%)',
    boxShadow: '0px 5px 10px 0px #00000026',
    height: '90px',
    borderRadius: '6px',
    alignItems: 'center',
    justifyContent: 'center',
    // border: '1px solid white',
    '&:hover': {
      boxShadow: '0px 5px 10px 0px rgba(239, 102, 155, 1)',
    },
  },
  customParagraph: {
    fontSize: '17px',
    color: '#712643',
    fontWeight: '400',
  },
  vectorImageAction: {
    paddingLeft: '5%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  customParagraphContent: {
    fontSize: '13px',
    fontStyle: 'italic',
    color: '#8D8D8D',
  },
  customParagraphAction: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: '-10px',
  },
  orButtonContainer: {
    width: '48px',
    height: '48px',
    backgroundColor: '#F2E2E8',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  orButtonContent: {
    color: 'black',
    fontSize: '18px',
  },
  imageContainer: {
    position: 'absolute',
    left: '0',
    zIndex: '2',
    maxWidth: '192px',
    maxHeight: '283px',
    width: '100%',
    height: '100%',
  },
  imageContent: {
    width: '156px',
  },
  trustTrovityIcon: {
    transform: 'scale(1.7)',
    width: '100%',
    height: '100%',
  },
})
